import { DealernetApi } from "./DealernetApi";

export const VISR_CONTROLLER_PATH = "/Visr";

const TERMS_FILE_NAME = "LNE - VISR Digital Services Terms.docx";

export interface IVisrConfigurationDto {
  TermsAndConditionsPicCodes: string[];
}

export interface IVisrTermsDto {
  Version: string;
  Html: string;
}

export class VisrService {
  public static async GetVisrConfiguration(): Promise<IVisrConfigurationDto> {
    const response = await DealernetApi.client().get(
      `${VISR_CONTROLLER_PATH}/GetConfiguration`
    );
    return response.data;
  }

  public static async GetTerms(): Promise<IVisrTermsDto> {
    const response = await DealernetApi.client().get(
      `${VISR_CONTROLLER_PATH}/GetTerms`
    );
    return response.data;
  }

  // Fetched via axios so the request carries the same auth headers as every other API call
  public static async DownloadTerms(): Promise<void> {
    const response = await DealernetApi.client().get(
      `${VISR_CONTROLLER_PATH}/DownloadTerms`,
      { responseType: "blob", headers: { Accept: "*/*" } }
    );

    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", TERMS_FILE_NAME);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}
